import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_NAMESPACE } from './log-sanitiser';
import { TelemetryService } from './telemetry.service';

/**
 * Adds the telemetry correlation id (X-Form-Session-Id) to every super-form
 * REST call (DEV-7864), so the WP plugin can tie each server-side outcome
 * (prematch, OTP, questions, …) to the form session. Before this only the
 * final send-request carried it.
 *
 * Only same-site super-form/v1 calls: the ERP API and third parties never get
 * the header, which would also trigger a CORS preflight there.
 */
@Injectable()
export class FormSessionInterceptor implements HttpInterceptor {

	constructor( private telemetryService: TelemetryService ) {
	}

	intercept( request: HttpRequest<unknown>, next: HttpHandler ): Observable<HttpEvent<unknown>> {

		if( ! FormSessionInterceptor.isSuperFormCall( request.url ) || request.headers.has( 'X-Form-Session-Id' ) ) {

			return next.handle( request );
		}

		return next.handle( request.clone( {
			setHeaders: { 'X-Form-Session-Id': this.telemetryService.getSessionId() },
		} ) );
	}

	public static isSuperFormCall( url: string ): boolean {

		try {

			const parsed = new URL( url, window.location.href );
			return parsed.origin === window.location.origin && parsed.pathname.includes( API_NAMESPACE );

		} catch {

			return false;
		}
	}
}
